import React, { memo } from 'react';
import classNames from 'classnames';
import cls from '../Calculations.module.css';
import { Input } from '../../../../../../components/newUI/Input/Input';

export const Square = memo(
    ({ isManualCalculations, onInput, calculations, manualCalculations }) => {
        return (
            <div className={classNames(cls)}>
                <div className={cls.columns}>
                    <Input
                        type={'measurements'}
                        inputName={'floor_area'}
                        onChange={onInput}
                        value={
                            (!isManualCalculations ? calculations : manualCalculations).floor_area
                        }
                        classes={cls.column}
                        placeholder={0}
                        label={i18next.t('Square.return.input.floorAreaLabel')}
                        isDisabled={!isManualCalculations}
                    />
                    <Input
                        type={'measurements'}
                        inputName={'ceiling_area'}
                        onChange={onInput}
                        value={
                            (!isManualCalculations ? calculations : manualCalculations).ceiling_area
                        }
                        classes={cls.column}
                        placeholder={0}
                        label={i18next.t('Square.return.input.ceilingAreaLabel')}
                        isDisabled={!isManualCalculations}
                    />
                    <Input
                        type={'measurements'}
                        inputName={'perimeter'}
                        onChange={onInput}
                        value={
                            (!isManualCalculations ? calculations : manualCalculations).perimeter
                        }
                        classes={cls.column}
                        placeholder={0}
                        label={i18next.t('Square.return.input.perimeterLabel')}
                        isDisabled={!isManualCalculations}
                    />
                </div>
                <div className={cls.columns}>
                    <Input
                        type={'measurements'}
                        inputName={'wall_area'}
                        onChange={onInput}
                        value={
                            (!isManualCalculations ? calculations : manualCalculations).wall_area
                        }
                        classes={cls.column}
                        placeholder={0}
                        label={i18next.t('Square.return.input.wallAreaLabel')}
                        isDisabled={!isManualCalculations}
                    />
                    <Input
                        type={'measurements'}
                        inputName={'without_opening'}
                        onChange={onInput}
                        value={
                            (!isManualCalculations ? calculations : manualCalculations)
                                .without_opening
                        }
                        classes={cls.column}
                        placeholder={0}
                        label={i18next.t('Square.return.input.withoutOpeningLabel')}
                        isDisabled={!isManualCalculations}
                    />
                    <Input
                        type={'measurements'}
                        inputName={'volume'}
                        onChange={onInput}
                        value={(!isManualCalculations ? calculations : manualCalculations).volume}
                        classes={cls.column}
                        placeholder={0}
                        label={i18next.t('Square.return.input.volumeLabel')}
                        isDisabled={!isManualCalculations}
                    />
                </div>
            </div>
        );
    }
);
